import { AppState } from 'src/app/store'

export const getOffersSelector = (state: AppState) => state.offers.offers
export const offersFilterTextSelector = (state: AppState) => state.offers.offers.filterText
export const declineOfferSelector = (state: AppState) => state.offers.declineOffer
export const acceptOfferSelector = (state: AppState) => state.offers.acceptOffer
export const sendRequestForProposalSelector = (state: AppState) => state.offers.sendRequestForProposal
